<template lang="html">
<div class="a7-painel-desktop">
  <div class="a7-painel-dashboard">
     <gw-card class="a7-filter-band">
      <div slot="body">
        <a7-painel-parameter @filtrou="emitFiltrou"/>
      </div>
    </gw-card>

     <gw-card class="a7-card-principal">
      <div slot="body">
        <a7-painel-tree
          :itens="itens"
          @agrupou="emitAgrupou"
          @selected-entity="seleciona"
          @show-info="informacao"/>
      </div>
    </gw-card>

    <div class="footer">
      <a7-historico-indicador class="historico"
        :filterParams="filtrosAtivos"
        :painelIndicadorDTO="selectedEntity"/>

      <gw-card class="card a7-card-avaliacao">
        <div slot="header">
          <div class="header">
            <span>Avaliação</span>
          </div>
        </div>
        <div slot="body" class="a7-card-avaliacao-body">
          <a7-painel-avaliacao
            :entity="selectedEntity"
            :filterParams="filtrosAtivos"/>
        </div>
      </gw-card>

      <gw-card class="card a7-card-resumo">
        <div slot="header">
          <div class="header">
            <span>Níveis de gestão</span>
          </div>
        </div>
        <div slot="body" class="a7-card-resumo-body">
          <a7-painel-resumo
            :entity="selectedEntity"
            :filterParams="filtrosAtivos"/>
        </div>
      </gw-card>
    </div>
  </div>

  <gw-modal-dialog :visible="showDialog" @hide="closeModal">
    <span slot="modal-header">{{`${$t('PainelMedicaoIndicador.ui.modal.dicionario')}`}}</span>
    <div slot="modal-body" class="modal-body-custom">
      <span v-text="informacaoDicionario.indicador" class="a7-dialog-indicador-label"/>
      <div class="a7-label-info-complementar">
        <div>
          <span>
            <span class="a7-label-info-complementar-indicador">
              {{`${$t('PainelMedicaoIndicador.ui.modal.unidadeMedida')}`}}
            </span>
            <span>{{informacaoDicionario.unidadeMedida}}</span>
          </span>
        </div>

        <div>
          <span>
            <span class="a7-label-info-complementar-indicador">
              {{`${$t('PainelMedicaoIndicador.ui.modal.desempenhoMinimo')}`}}
            </span>
            <span>{{informacaoDicionario.desempenhoMinimo}}</span>
          </span>
        </div>

        <div>
          <span>
            <span class="a7-label-info-complementar-indicador">
              {{`${$t('PainelMedicaoIndicador.ui.modal.desempenhoMaximo')}`}}
            </span>
            <span>{{informacaoDicionario.desempenhoMaximo}}</span>
          </span>
        </div>
      </div>

      <gw-tabbed-pane>
        <gw-tab :title="$t('PainelMedicaoIndicador.ui.modal.objetivo')">
          <template>
            <span v-text="informacaoDicionario.objetivo"/>
          </template>
        </gw-tab>
        <gw-tab :title="$t('PainelMedicaoIndicador.ui.modal.procedimento')">
          <template>
            <span v-text="informacaoDicionario.procedimento"/>
          </template>
        </gw-tab>
        <gw-tab :title="$t('PainelMedicaoIndicador.ui.modal.risco')">
          <template>
            <span v-text="informacaoDicionario.risco"/>
          </template>
        </gw-tab>
      </gw-tabbed-pane>
    </div>
    <div slot="modal-footer">
      <button class="btn btn-primary" type="button" name="ok" @click="closeModal">
        Fechar
      </button>
    </div>
  </gw-modal-dialog>
</div>
</template>

<script>
import {
  GwCard,
  GwModalDialog,
  GwTabbedPane,
  GwTab
} from 'guaxinim-web'

import A7HistoricoIndicador from './A7HistoricoIndicador'
import A7PainelParameter from './A7PainelParameter'
import A7PainelTree from './A7PainelTree'
import A7PainelAvaliacao from './A7PainelAvaliacao'
import A7PainelResumo from './A7PainelResumo'
import IndicadorRestResource from '../indicador/IndicadorRestResource'


export default {
  name: 'a7-painel',
  components: {
    GwCard,
    GwModalDialog,
    GwTabbedPane,
    GwTab,
    A7HistoricoIndicador,
    A7PainelParameter,
    A7PainelTree,
    A7PainelAvaliacao,
    A7PainelResumo
  },
  props: {
    itens: {
      type: Array,
      required: true
    },
    filtrosAtivos: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      selectedEntity: null,
      informacaoDicionario: {},
      showDialog: false
    }
  },
  methods: {
    closeModal() {
      this.showDialog = false
    },
    emitFiltrou(value) {
      this.$emit('filtrou', value)
    },
    emitAgrupou(value) {
      this.$emit('agrupou', value)
    },
    seleciona( entity ){
      this.selectedEntity = entity
    },
    informacao( entidade ){
      IndicadorRestResource.findDicionarioIndicadorDTObyID(entidade.indicadorID)
      .then(indicador => {
        const dicionario = {
          indicador: indicador.nome,
          objetivo: indicador.objetivo,
          procedimento: indicador.procedimento,
          risco: indicador.risco,
          unidadeMedida: indicador.medicaoUnidadeMedida,
          desempenhoMaximo: indicador.desempenhoMaximo,
          desempenhoMinimo: indicador.desempenhoMinimo
        }
        this.informacaoDicionario = dicionario
        this.showDialog = !this.showDialog
      })
    }
  }
}
</script>


<style lang="scss" scoped>
@import './A7PainelFormatacao';

.a7-dialog-indicador-label {
  font-size: $tamanhoFonteGrande;
  display: block;
  font-weight: $weight;
  color: #72767b;
  padding-bottom: 10px;
}

.a7-label-info-complementar{
  display: flex;
  max-width: 90%;
  justify-content: space-between;
}

.a7-label-info-complementar-indicador {
    font-weight: $weight;
}

.a7-painel-desktop {
  height: 100%;
}
.a7-painel-dashboard {
  display: grid;
  width: 100%;
  height: 100%;
  padding: 4px 4px 0px 4px;
  overflow: auto;
  background-color: $grey-lighter;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: min-content auto min-content;
  grid-template-areas:
    "filterBand filterBand filterBand"
    "principal principal principal"
    "footer footer footer";
}

.a7-filter-band {
  grid-area: filterBand;
}

.a7-card-principal{
  grid-area: principal;
  overflow-x: auto;
  min-height: 335px;
}

.footer {
  grid-area: footer;
  padding-bottom: 4px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "historico a7CardAvaliacao a7CardResumo";
}
.card {
  .header {
    display: flex;
    font-size: $tamanhoFonteGrande;
    border: none !important;
    align-items: center;
    margin: 0px -10px;
    height: 55px;
    width: 100%;
  }
}

.historico{
  grid-area: historico;
}
.a7-card-avaliacao{
  grid-area: a7CardAvaliacao;
  .a7-card-avaliacao-body {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.a7-card-resumo {
  grid-area: a7CardResumo;
}

.modal-body-custom{
  width: 550px;
}
</style>

<style>
.a7-painel-dashboard .progress {
  margin-bottom: 0;
}

.a7-painel-dashboard .gw-progress-top {
  position: absolute;
}

.a7-painel-dashboard .gw-table-cell-selected .a7-info-icon {
  color: #aaf;
}
</style>
